import { fromIsoDay } from "components/crm/ui/crmTime";
import {
  DEFAULT_CALL_RULES,
  clock,
  longDay,
  whenKey,
} from "pages/prospection/callTime";

export const RESULTS = ["answered", "callback", "no_answer", "not_interested"];

export const missedInARow = (calls) => {
  let count = 0;
  for (const call of calls || []) {
    if (call.result !== "no_answer") break;
    count += 1;
  }
  return count;
};

export const currentAttempt = (calls) => missedInARow(calls) + 1;

// threshold: the no-answer attempt from which the api creates a prospection
// visit on its own (callRules.noAnswerThreshold); nothing is chosen then.
export const canConfirm = ({
  result,
  note,
  at,
  history,
  attempt,
  threshold = DEFAULT_CALL_RULES.noAnswerThreshold,
}) => {
  const hasNote = !!note && note.trim() !== "";
  switch (result) {
    case "answered":
    case "not_interested":
      return hasNote;
    case "callback":
      return hasNote && !!at;
    case "no_answer":
      return history != null && (attempt >= threshold || !!at);
    default:
      return false;
  }
};

// callbackContactRef: whom « À rappeler » calls back (null: the standard),
// left out when not given (JBWEB-1459).
const buildFollowUp = ({ result, visit, at, attempt, threshold, callbackContactRef }) => {
  if (result === "answered") return { visit: !!visit };
  if (result === "callback")
    return {
      at: at.toISOString(),
      ...(callbackContactRef !== undefined ? { contactRef: callbackContactRef } : {}),
    };
  if (result === "no_answer" && attempt < threshold) {
    return { at: at.toISOString() };
  }
  return undefined;
};

export const buildConfirmBody = ({
  company,
  line,
  sessionId,
  result,
  note,
  visit,
  at,
  attempt,
  threshold = DEFAULT_CALL_RULES.noAnswerThreshold,
  callbackContactRef,
}) => ({
  companyId: company.id,
  callbackId: line?.id ?? null,
  sessionId: sessionId ?? null,
  result,
  note: note.trim(),
  contactName: company.contactName || "",
  followUp: buildFollowUp({ result, visit, at, attempt, threshold, callbackContactRef }),
});

const ORDINAL_KEYS = { 1: "one", 2: "two", 3: "three" };

export const ordinal = (n, text) =>
  text(`qualification.ordinal.${ORDINAL_KEYS[n] || "other"}`, { n });

export const whenText = (at, now, text, locale) =>
  text(`when.${whenKey(at, now)}`, {
    time: clock(at),
    day: longDay(at, locale),
  });

// Dates come from the api response, never from the user's choice: the server
// may have kept an earlier callback time.
export const confirmMessage = (
  response,
  {
    company,
    now,
    text,
    locale,
    threshold = DEFAULT_CALL_RULES.noAnswerThreshold,
  }
) => {
  const values = { company: company.name, n: response.attempt, max: threshold };
  if (response.visit) {
    values.date = longDay(fromIsoDay(response.visit.dueBy), locale);
  }
  if (response.dueAt) {
    values.when = whenText(new Date(response.dueAt), now, text, locale);
  }
  return text(`confirmed.${response.outcome}`, values);
};
